import { useState } from "react";
import { format, parseISO } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Step4DateTime({ data, update }) {
  const [open, setOpen] = useState(false);
  const selectedDate = data.preferred_date ? parseISO(data.preferred_date) : undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div className="space-y-6" data-testid="step-4-datetime">
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Preferred date</h2>
        <p className="mt-2 text-slate-600">Choose the day that works best for you. We'll confirm availability by email.</p>
      </div>

      <div className="sm:max-w-sm">
        <Label className="text-slate-700 font-medium">Preferred date</Label>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              data-testid="btn-date-picker"
              className="mt-1.5 w-full h-12 justify-start text-left font-normal bg-white border-slate-200 hover:bg-slate-50"
            >
              <CalendarIcon className="h-4 w-4 text-[#FF7F00]" />
              {selectedDate ? format(selectedDate, "EEEE, d MMM yyyy") : <span className="text-slate-400">Select a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-white" align="start" data-testid="date-picker-popover">
            <Calendar
              mode="single"
              selected={selectedDate}
              onSelect={(d) => {
                if (d) update({ preferred_date: format(d, "yyyy-MM-dd") });
                setOpen(false);
              }}
              disabled={(date) => date < today}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>

      <div>
        <Label htmlFor="access" className="text-slate-700 font-medium">Access / parking notes (optional)</Label>
        <Textarea
          id="access"
          data-testid="input-access-notes"
          value={data.access_notes}
          onChange={(e) => update({ access_notes: e.target.value })}
          placeholder="e.g. Alley access at rear, keysafe code 1234, permit required on street…"
          rows={4}
          className="mt-1.5 bg-white border-slate-200 focus-visible:ring-[#FF7F00]"
        />
      </div>
    </div>
  );
}
